var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStickyNoteFill = function SvgStickyNoteFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.75 12.25-4.5 4.497-8.248.003a.75.75 0 0 1-.752-.745V3.995c0-.411.334-.745.745-.745h12.01c.411 0 .745.342.745.752zm-1.5-7.5H4.75v10.5h6V11.5a.75.75 0 0 1 .662-.745l.088-.005h3.75zm-.622 7.5H12.25v2.377l2.378-2.378Z"
  })));
};
export default SvgStickyNoteFill;